<template>
	<Popup v-model="selfDisplay" title="修改疾病" confirmBtnText="修改" @confirmClick="handleUpdateClick">
		<div v-loading="loading" style="padding: 15px;">

			<div class="base_form_row">
				<span class="b_label"><span style="color: #f00;">*</span>序号</span>
				<el-input v-model="diseaseNo" placeholder="序号"></el-input>
			</div>
			<div class="base_tip" style="padding: 0 0 0 120px;"><template v-if="nameTip"><i
						class="b_icon"></i>请输入序号</template></div>


			<div class="base_form_row">
				<span class="b_label"><span style="color: #f00;">*</span>疾病名称</span>
				<el-input v-model="name" placeholder="疾病名称"></el-input>
			</div>
			<div class="base_tip" style="padding: 0 0 0 120px;"><template v-if="nameTip"><i
						class="b_icon"></i>请输入疾病名称</template></div>

			<div class="base_form_row">
				<span class="b_label"><span style="color: #f00;">*</span>疾病图标</span>
				<div v-if="!icon" class="b_upload b_inline_block">
					<el-button type="primary">点击上传</el-button>
					<input type="file" accept="image/*" @change="handleIconUpload" />
					<span class="b_upload_tip">最好是方形小图！！！</span>
				</div>
				<div v-if="icon" class="b_upload b_inline_block" style="border: 1px solid #ccc;">
					<img :src="icon" alt="" style="">
					<i @click="handleIconDelete"></i>
				</div>
			</div>
			<div class="base_tip" style="padding: 0 0 0 120px;"><template v-if="iconTip"><i
						class="b_icon"></i>请上传疾病图标</template></div>
		</div>
	</Popup>
</template>

<script>
	import Api from '../../../../../../../api/index.js';
	import BaseMethods from '../../../../../../../assets/js/base.js';

	export default {
		model: {
			prop: 'display',
			event: 'changeDisplay'
		},
		props: {
			display: Boolean,
			obj: {
				type: Object,
				default () {
					return {};
				}
			}
		},
		mounted() {
			this.display && (this.selfDisplay = true);
		},
		data() {
			return {
				loading: false,
				selfDisplay: false,
				name: '',
				diseaseNo: '',
				icon: '',
				diseaseNoTIP: false,
				nameTip: false,
				iconTip: false
			}
		},
		methods: {
			// 点击修改
			handleUpdateClick() {
				if (!this.diseaseNo.trim()) {
					this.diseaseNoTIP = true;
					return false;
				} else if (!this.name.trim()) {
					this.nameTip = true;
					return false;
				} else {
					this.nameTip = false;
				}
				this.update();
			},
			// 修改
			update() {
				const that = this;
				that.loading = true;
				let requestData = {
					id: that.obj.id,
					diseaseNo:that.diseaseNo,
					diseaseName: that.name,
					diseaseDesc: '',
					diseaseMarketing: '',
					diseaseImg: that.icon,
					typeChannel: 2
				};
				Api.updateDiseaseForAppAndMall(requestData).then((res) => {
					if (res.data.success) {
						that.loading = false;
						that.$message.success(res.data.message);
						that.selfDisplay = false;
						that.$emit('onSuccess');
					} else {
						that.loading = false;
						that.$message.error(res.data.message);
					}
				}, (e) => {
					that.loading = false;
					that.$message.error(e.message);
				});
			},
			// 上传图片
			handleIconUpload(e) {
				const that = this;
				BaseMethods.uploadMultiImg(e, (base64, imgs_type, imgs_name) => {
					that.uploadIcon(base64[0], imgs_type[0], imgs_name[0]);
				}, (msg) => {
					that.$message.error(msg);
				});
			},
			// 删除上传的图片
			handleIconDelete() {
				this.icon = '';
			},
			// 上传图片
			uploadIcon(base64, img_type, fileName) {
				const that = this;
				that.loading = true;
				let iconName = `${ new Date().getTime() }_${ fileName }`;
				let requestData = {
					base: base64,
					picName: iconName,
					type: 'uGateWayUrl'
				};
				Api.uploadPic(requestData).then((res) => {
					if (res.data.success) {
						that.loading = false;
						that.icon = res.data.data.imgUrl.split('?')[0];
					} else {
						that.loading = false;
						that.$message.error(res.data.message);
					}
				}, (e) => {
					that.loading = false;
					that.$message.error(e.message);
				});
			}
		},
		watch: {
			display(newVal) {
				this.selfDisplay = newVal;
			},
			selfDisplay(newVal) {
				this.$emit("changeDisplay", newVal);
				if (newVal) {
					this.loading = false;
					this.name = this.obj.name;
					this.diseaseNo = this.obj.diseaseNo;
					this.icon = this.obj.icon;
					this.diseaseNoTIP = false;
					this.nameTip = false;
					this.iconTip = false;
				}
			}
		}
	}
</script>

<style>
</style>
